export const BUTTON_SIZE = 56 * 1.5
